import logo from "../../../assets/images/logo/mp-logo.png";

const MealprepLogo = ({ classes, id, alt }) => {
  return <img src={logo} className={classes} id={id} alt={alt} />;
};
export default MealprepLogo;
